export function formatBRLFromCents(value: number): string {
  const reais = (Number(value) || 0) / 100;
  return reais.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}
